(() => {
  const checkoutUrl = new URL('/checkout', window.location.origin).toString();

  const init = (root) => {
    if (!root || root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';

    const variants = JSON.parse(root.querySelector('[data-hh-variants]')?.textContent || '[]');
    const form = root.querySelector('form[data-type="add-to-cart-form"]');
    const idInput = root.querySelector('[data-hh-variant-id]');
    const price = root.querySelector('[data-hh-price]');
    const stock = root.querySelector('[data-hh-stock]');
    const submit = root.querySelector('.hh-pdp__add');
    const buyNow = root.querySelector('[data-hh-buy-now]');
    const errorWrapper = root.querySelector('.product-form__error-message-wrapper');
    const errorMessage = root.querySelector('.product-form__error-message');

    let selectedAvailable = !buyNow?.disabled;

    const money = (cents) => new Intl.NumberFormat(
      document.documentElement.lang || 'en',
      {
        style: 'currency',
        currency: window.Shopify?.currency?.active || 'EUR',
      }
    ).format(cents / 100);

    const showError = (message = '') => {
      if (!errorWrapper || !errorMessage) return;
      errorMessage.textContent = message;
      errorWrapper.hidden = !message;
    };

    const selectMedia = (id) => {
      if (!id) return;
      root.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.toggle(
          'is-active',
          String(element.dataset.mediaId) === String(id)
        );
      });
      root.querySelectorAll('[data-media-target]').forEach((element) => {
        element.classList.toggle(
          'is-active',
          String(element.dataset.mediaTarget) === String(id)
        );
      });
    };

    root.querySelectorAll('[data-media-target]').forEach((button) => {
      button.addEventListener('click', () => selectMedia(button.dataset.mediaTarget));
    });

    const updateVariant = () => {
      const values = [...root.querySelectorAll('.hh-pdp__option')]
        .map((group) => group.querySelector('input:checked')?.value);

      if (!values.length) return;

      const variant = variants.find((item) =>
        item.options.every((value, index) => value === values[index])
      );

      if (!variant) {
        selectedAvailable = false;
        if (submit) submit.disabled = true;
        if (buyNow) buyNow.disabled = true;
        return;
      }

      selectedAvailable = Boolean(variant.available);
      idInput.value = variant.id;

      if (price) price.textContent = money(variant.price);

      if (submit) {
        submit.disabled = !variant.available;
        const label = submit.querySelector('span');
        if (label) {
          label.textContent = variant.available
            ? (submit.dataset.addLabel || window.variantStrings?.addToCart || '')
            : (window.variantStrings?.soldOut || '');
        }
      }

      if (buyNow) buyNow.disabled = !variant.available;

      if (stock) {
        stock.textContent = variant.available
          ? stock.dataset.inStock
          : stock.dataset.outOfStock;
      }

      if (variant.featured_media?.id) selectMedia(variant.featured_media.id);

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
      showError('');
    };

    root.querySelectorAll('.hh-pdp__option input').forEach((input) => {
      input.addEventListener('change', updateVariant);
    });

    root.querySelectorAll('[data-tab]').forEach((tab) => {
      tab.addEventListener('click', () => {
        root.querySelectorAll('[data-tab]').forEach((element) => {
          const active = element === tab;
          element.classList.toggle('is-active', active);
          element.setAttribute('aria-selected', String(active));
        });

        root.querySelectorAll('[data-tab-panel]').forEach((element) => {
          element.classList.toggle(
            'is-active',
            element.dataset.tabPanel === tab.dataset.tab
          );
        });
      });
    });

    const dialog = root.querySelector('[data-size-guide]');
    root.querySelectorAll('[data-size-guide-open]').forEach((button) => {
      button.addEventListener('click', () => dialog?.showModal());
    });
    root.querySelector('[data-size-guide-close]')?.addEventListener(
      'click',
      () => dialog?.close()
    );

    buyNow?.addEventListener('click', async () => {
      if (!form || !idInput?.value || !selectedAvailable) return;

      const originalLabel = buyNow.dataset.buyLabel || buyNow.textContent.trim();
      const processingLabel = buyNow.dataset.processingLabel || originalLabel;
      const fallbackError = buyNow.dataset.errorLabel || 'Unable to start checkout.';

      buyNow.disabled = true;
      buyNow.textContent = processingLabel;
      showError('');

      try {
        const formData = new FormData(form);
        formData.set('id', idInput.value);

        if (!formData.get('quantity')) {
          formData.set('quantity', '1');
        }

        const response = await fetch(
          window.routes?.cart_add_url || '/cart/add.js',
          {
            method: 'POST',
            body: formData,
            credentials: 'same-origin',
            headers: {
              Accept: 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
            },
          }
        );

        const result = await response.json().catch(() => ({}));

        if (!response.ok) {
          throw new Error(result.description || result.message || fallbackError);
        }

        // Origin-absolute checkout avoids invalid localized paths such as /de/checkout.
        window.location.assign(checkoutUrl);
      } catch (error) {
        showError(error?.message || fallbackError);
        buyNow.disabled = !selectedAvailable;
        buyNow.textContent = originalLabel;
      }
    });
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll?.('[data-hh-pdp]').forEach(init);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
  });
})();
